import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';

import { signinUser } from '../actions';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const SignIn = (props) => {
  const classes = useStyles();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [signInError, setSignInError] = useState(false);

  const onError = () => {
    setSignInError(true);
  };

  const handleSignIn = () => {
    setSignInError(false);

    // Input checking
    setEmailError(email.trim() === '');
    setPasswordError(password.trim() === '');

    // Cont'd
    if (email.trim() === '' || password.trim() === '') {
      console.log('Invalid input');
    } else {
      // Arrange user data and make API call
      const user = {
        email: email.trim(),
        password: password.trim(),
      };
      props.signinUser(user, props.history, onError);
    }
  };

  // useEffect(() => {
  //   const listener = (event) => {
  //     if (event.code === 'Enter') {
  //       handleSignIn();
  //     }
  //   };
  //   document.addEventListener('keydown', listener);
  //   return () => {
  //     document.removeEventListener('keydown', listener);
  //   };
  // }, []);

  return (
    <div>
      <Container component="main" maxWidth="sm" className="signin-modal">
        <IconButton type="button" href="/">
          <CloseIcon />
        </IconButton>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <form className={classes.form} noValidate>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  onChange={(event) => setEmail(event.target.value)}
                  error={emailError}
                  onKeyPress={(res) => {
                    if (res.key === 'Enter') {
                      handleSignIn();
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  onChange={(event) => setPassword(event.target.value)}
                  error={passwordError}
                  onKeyPress={(res) => {
                    if (res.key === 'Enter') {
                      handleSignIn();
                    }
                  }}
                />
              </Grid>
            </Grid>
            <Button
              type="button"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={handleSignIn}
            >
              Sign In
            </Button>
            <Grid container direction="row" justify="center">
              {signInError ? (
                <Typography variant="subtitle1">
                  Error during sign in. Please try again.
                </Typography>
              ) : undefined}
            </Grid>
          </form>
        </div>
      </Container>
    </div>
  );
};

export default withRouter(connect(null, { signinUser })(SignIn));
